import { useMutation, useQueryClient } from 'react-query'
import { useNavigate } from 'react-router-dom'
import { toast } from 'react-toastify'
import { axios } from '../../../lib'

const createUser = (data: any): Promise<any> => {
  return axios.post(`users`, data)
}

export function useCreateUser() {
  const queryClient = useQueryClient()
  const navigate = useNavigate()

  return useMutation(createUser, {
    onSuccess: () => {
      queryClient.invalidateQueries('users')
      toast.success('Usuário cadastrado com sucesso!')
      navigate('/users')
    },
    onError: (error: unknown) => {
      console.log(error)
      toast.error('Não foi possível cadastrar o usuário')
    }
  })
}
